import { render, staticRenderFns } from "./CampaignUserAdd.vue?vue&type=template&id=28e3a95b&scoped=true"
import script from "./CampaignUserAdd.vue?vue&type=script&lang=js"
export * from "./CampaignUserAdd.vue?vue&type=script&lang=js"
import style0 from "./CampaignUserAdd.vue?vue&type=style&index=0&id=28e3a95b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e3a95b",
  null
  
)

export default component.exports